<template>
  <div class="hello">
    <StreamBarcodeReader
      @decode="(a, b, c) => onDecode(a, b, c)"
      @loaded="() => onLoaded()"
    ></StreamBarcodeReader>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import axios from "axios";

export default {
  name: "BarcodeReader",
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      text: "",
      id: null,
      crmID: "",
      url: "https://engeocentr.bitrix24.ru/rest/839/wnal269dpe5j3ew9/",
    };
  },
  props: {
    msg: String,
    isTrue: Boolean,
  },
  methods: {
    async onDecode(a, b, c) {
      console.log(a, b, c);
      console.log(this.isTrue, "isTrue");
      this.text = a;

      this.crmID = this.text;
      const deal = await axios.post(this.url + "crm.deal.get", {
        id: this.crmID,
      });
      console.log({ deal });
      if (deal.data.result.TITLE == "VIP") {
        alert("Перед вами VIP-гость!");
      } else {
        if (deal.data.result.CLOSED == "Y") {
          alert("Клиент с данным билетом уже зарегистрирован!");
        } else {
          alert("Клиент зарегистрирован!");
          await axios.post(this.url + "crm.deal.update", {
            id: this.crmID,
            fields: {
              STAGE_ID: "C19:WON",
            },
          });
        }
      }
      //  }

      this.text = "";
      this.crmID = "";

      console.log(this.crmID);
    },
    onLoaded() {
      console.log("load");
    },
  },
};
</script>
<style scoped></style>
